import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { z } from 'zod';

import { useForgotPassword } from '../../query/auth';

import InputField from '../fields/input-field';
import { Button } from '../ui/button';
import { Form } from '../ui/form';

const formSchema = z.object({
  email: z
    .string({ required_error: '이메일을 입력해주세요.' })
    .email('유효한 이메일 주소를 입력해주세요.'),
});

type FormData = z.infer<typeof formSchema>;

const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const form = useForm<FormData>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: '',
    },
    reValidateMode: 'onChange',
  });
  const { mutate: forgotPassword, isPending: isForgotPassword } = useForgotPassword();
  const onSubmit = (data: FormData) => {
    forgotPassword(data, {
      onSuccess: () => {
        toast.success('비밀번호 찾기 이메일을 보냈습니다. 이메일을 확인해주세요.');
        navigate('/', { replace: true });
      },
      onError: () => {
        toast.error('비밀번호 찾기 이메일을 보내는데 문제가 발생했습니다.');
      },
    });
  };
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <InputField
          control={form.control}
          name="email"
          placeholder="이메일을 입력해주세요."
          label="이메일"
          type="email"
        />

        <div className="flex w-full items-center justify-center gap-4">
          <Button type="submit" disabled={isForgotPassword}>비밀번호 찾기</Button>
        </div>
      </form>
    </Form>
  );
};

export default ForgotPasswordForm;
